// extracted by mini-css-extract-plugin
export default {"pageWrap":"ec-z","fullWidth":"fc-z","heading":"gc-z","fullBleed":"hc-z","hidden":"ic-z"};